import { render } from "./PopUp.vue?vue&type=template&id=19cfd999&scoped=true"
import script from "./PopUp.vue?vue&type=script&lang=js"
export * from "./PopUp.vue?vue&type=script&lang=js"

import "@/assets/styles/popup.scss?vue&type=style&index=0&id=19cfd999&scoped=true&lang=scss"

import exportComponent from "/home/djokic/Projects/mariv/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19cfd999"]])

export default __exports__